var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOutOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C7.54386 17 5 14.4561 5 11C5 7.54386 7.54386 5 11 5C14.4561 5 17 7.54386 17 11C17 14.4561 14.4561 17 11 17ZM11 19C15.4386 19 19 15.4386 19 11C19 6.5614 15.4386 3 11 3C6.5614 3 3 6.5614 3 11C3 15.4386 6.5614 19 11 19ZM20.7018 19.2982L16.7018 15.2982C16.5263 15.1053 16.2807 15 16 15C15.4561 15 15 15.4561 15 16C15 16.2807 15.1053 16.5263 15.2982 16.7018L19.2982 20.7018C19.4737 20.8947 19.7193 21 20 21C20.5439 21 21 20.5439 21 20C21 19.7193 20.8947 19.4737 20.7018 19.2982ZM8 12H14C14.5439 12 15 11.5439 15 11C15 10.4561 14.5439 10 14 10H8C7.45614 10 7 10.4561 7 11C7 11.5439 7.45614 12 8 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutOutlined);
export default __webpack_public_path__ + "static/media/zoom_out_outlined.02505c7d.svg";
export { ForwardRef as ReactComponent };